import { CheckCircle2 } from 'lucide-react'
import PropTypes from 'prop-types'

import { FormModal, FormModalFooter } from '@components/branded-modal'

/** Support → Create Request: shown once a request is submitted. CAR-4050: the standard pop-up. */
export const SuccessModal = ({ open, requestNumber, handleClose }) => (
  <FormModal
    open={open}
    onClose={handleClose}
    icon={CheckCircle2}
    title={`Request #${requestNumber} submitted`}
    width='max-w-[480px]'
    clientMayEdit
    footer={<FormModalFooter onConfirm={handleClose} confirmLabel='Close' />}
  >
    <p className='text-[13px] leading-5 text-[#334155]'>
      Please ensure all documents are attached to the <strong>Quote/WO/Invoice</strong> for a quicker resolution.
    </p>
  </FormModal>
)

SuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  requestNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleClose: PropTypes.func.isRequired
}
